import RestApiModel from "@/api/Model/RestApiModel";

class OrderSubmission extends RestApiModel {
  static getResourceEndpoint() {
    return '/OrderSubmission';
  }
}

export default OrderSubmission;
